import type { QueryClient } from 'react-query'
import { primeLookup } from '@/hooks/useEntityLookup'
import { ApiInstance } from '@/lib/api'
import { isNotFound } from '@/lib/errors'
import { CUSTOMER_LOOKUP } from '@/lib/lookups'
import type { CustomerType } from '@/lib/types'

export const customerQueryKey = (id?: string) => ['customer', id]

export const CUSTOMER_SENSITIVE_FIELDS = ['document', 'rg', 'spouseDocument'] as const

export const customerSensitiveEndpoint = (id: string) => `/customers/${id}/sensitive`

export async function fetchCustomer(id: string): Promise<CustomerType> {
  const { data } = await ApiInstance.get<CustomerType>(`/customers/${id}`)
  return data
}

export const retryCustomer = (count: number, error: unknown) => !isNotFound(error) && count < 2

export function syncCustomerLookups(queryClient: QueryClient, customer: CustomerType) {
  primeLookup(queryClient, CUSTOMER_LOOKUP, [customer])
  queryClient.invalidateQueries(['lookup', CUSTOMER_LOOKUP.key])
}

export function invalidateCustomerLists(queryClient: QueryClient, id?: string) {
  queryClient.invalidateQueries(['customers'])
  if (id) {
    queryClient.invalidateQueries(customerQueryKey(id))
    queryClient.invalidateQueries(['rent-contract-customer', id])
  }
}
